import React, { Component } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import BaseApp from "./BaseApp";
import { reportError } from "./utility/api";
import $ from "jquery";
import { AdvertisementAll } from "./components/base/Advertisement";
import "./style/sass/main.scss";
import { windowLet } from "~/utility/global";
import store from "./store/store";

if (process.env.BUILD_TARGET == "client") {
  // window.addEventListener("error", function(errorEvent){
  window.onerror = function (errorEvent: ErrorEvent) {
    console.log(arguments);
    console.log("got error", errorEvent);
    reportError(errorEvent);
    throw errorEvent;
  };

  // });
}

const supportsHistory = "pushState" in windowLet.history;
class App extends Component {
  UNSAFE_componentWillMount() {
    if (process.env.BUILD_TARGET === "client") {
      // this.oldDollar = window.$
      window.$ = $;
    }
  }

  render() {
    return (
      <AdvertisementAll>
        <Router forceRefresh={!supportsHistory}>
          <Provider store={store}>
            <BaseApp />
          </Provider>
        </Router>
      </AdvertisementAll>
    );
  }
}

export default App;
